import { translateGroupChildren } from '../../items/group/translate-group-children';
import { EditorStarterItem } from '../../items/item-type';
import { EditorState } from '../types';
import { changeItem } from './change-item';

/**
 * 주어진 아이템 ID 목록에 동일한 업데이트를 적용한다.
 * 내부에서 얕은 복사를 최소화하며, 변경이 없는 경우 원본 state를 그대로 반환한다.
 */
export const changeItems = (
  state: EditorState,
  itemIds: string[],
  updater: (item: EditorStarterItem) => EditorStarterItem,
): EditorState => {
  const targetIds = Array.from(new Set(itemIds));

  if (targetIds.length === 0) {
    return state;
  }

  const items = state.undoableState.items;
  let itemsChanged = false;
  let updatedItems = items;

  for (const targetId of targetIds) {
    const existingItem = items[targetId];

    if (!existingItem) {
      continue;
    }

    const nextItem = updater(existingItem);

    if (nextItem !== existingItem) {
      if (!itemsChanged) {
        updatedItems = {
          ...items,
        };
        itemsChanged = true;
      }

      updatedItems[targetId] = nextItem;
      // 그룹 이동이면 children 에 delta 전파(그룹 bbox 는 SoT 가 아님). changeItem 과 동일.
      updatedItems = translateGroupChildren(
        updatedItems,
        existingItem,
        nextItem,
      );
    }
  }

  if (!itemsChanged) {
    return state;
  }

  return {
    ...state,
    undoableState: {
      ...state.undoableState,
      items: updatedItems,
    },
  };
};

/**
 * 단일 선택과 다중 선택을 모두 지원하기 위한 래퍼.
 * 대상 배열 길이에 따라 `changeItems` 또는 `changeItem`을 호출해 의도한 범위를 명확히 한다.
 */
export const changeItemsWithSelection = (
  state: EditorState,
  itemId: string,
  targetItemIds: string[],
  updater: (item: EditorStarterItem) => EditorStarterItem,
): EditorState => {
  if (targetItemIds.length > 1) {
    return changeItems(state, targetItemIds, updater);
  }

  return changeItem(state, itemId, updater);
};
